<template>
    <div class="icon-list">
        <template v-for="(icon, type) in icons" :key="type">
            <ui-icon :type="type" size="30" color="#5a5e66" @iconclick="onClick(type)" />
        </template>
    </div>
</template>

<script>
    import icons from './icons.js'

    export default {
        data() {
            return {
                icons: icons
            }
        },
        methods: {
            onClick(e) {
                this.$emit('iconListClick', e)
            }
        }
    }
</script>

<style scoped>
    .icon-list{
        height: calc(100vh - 400px);
        overflow: auto;
        display: flex;
        flex-wrap: wrap;
        padding-left: 1px;
        padding-top: 1px;
    }
    .icon-list .ui-icon{
        margin-top: -1px;
        margin-left: -1px;
        padding: 15px;
        border: 1px solid #eeeeee;
    }
</style>
